/* eslint-disable */
import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { AiOutlineArrowLeft } from 'react-icons/ai'
import useEmbedded from '../hooks/useEmbedded'

function OpenStax() {
  const { slug } = useParams()
  const navigate = useNavigate()
  const embedded = useEmbedded()
  const src = `/openstax/${slug}/`

  return (
    <div className="fixed inset-0 w-full h-full overflow-hidden">
      {!embedded && (
        <AiOutlineArrowLeft
          className="fixed z-50 m-2 top-0 left-0 text-3xl text-gray-900 transition-colors hover:cursor-pointer dark:text-gray-100"
          onClick={() => {
            navigate('/')
          }}
        />
      )}
      <div className="absolute inset-0 md:inset-x-[8.333%] overflow-hidden">
        <iframe 
          title={slug} 
          src={src} 
          scrolling="no"
          className="w-full h-full border-0 bg-[#1f2736]" 
          style={{ display: 'block', margin: 0, padding: 0, overflow: 'hidden' }} 
        />
      </div>
    </div>
  )
}

export default OpenStax


